import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";
import { getQuery } from "../_helpers/query.helper";

const API_NAME = "ticketPurgeLog";

export const ticketPurgeLogService = {
    getAll,
    get,
    post,
};

function getAll(query: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAll?${getQuery(query)}`, requestOptions).then(handleResponse);
}

function get(startDate: string, endDate: string, ticketTypeId?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    const params = new URLSearchParams({ startDate, endDate });

    if (ticketTypeId !== null && ticketTypeId !== undefined)
        params.append("ticketTypeId", ticketTypeId.toString());

    return fetch(
        `${API_URL}/${API_NAME}/Get?${params.toString()}`, requestOptions).then(handleResponse);
}

function post(model: any) {
    const requestOptions = { method: 'POST', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/create`, requestOptions).then(handleResponse);
}

